import React from 'react'
import './Style/Product.css'
import Logo from '../Image/Logo.png'
import ReactHTMLTableToExcel from "react-html-table-to-excel";
function Product({data,info,total,discount,lastPrice}) {
  return <div className="table w-full md:px-10 px-4 md:mt-10 mt-2 md:mb-10 mb-4">
      <table className='w-full mb-10' id='table-invoice'>
        <thead>
            <tr>
                <th className="th-first">Description</th>
                <th className="th-center">Price</th>
                <th className="th-center">QTY</th>
                <th className="th-end">Total</th>
            </tr>
        </thead>

        {data.map((item,key)=>(
            <tr key={key}>
                  <td className='td-first'>{item.description} </td>
                  <td className='td-center'> {item.price}$ </td>
                  <td className='td-center'> {item.qty} </td>
                  <td className='td-end'> {item.price * item.qty}$ </td>
            </tr>
        ))}
      </table>
      <div className='button-export-to-exsel'>
      <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button"
            table="table-invoice"
            filename="tablexls"
            sheet="tablexls"
            buttonText="Print To Excel"
      />
    </div>

        <div className='productInfo grid grid-cols-2 py-5 md:px-20 px-4 flex items-center'>
            <div className='col-span-1'>
                <img src={Logo} alt=''className='w-20'/>
                <p className='font-black mt-1 text-xs'>Clothing Co.</p>
            </div>
            <div className='col-span-1 text-right'>
                <div className='flex justify-between items-center'>
                      <div className='basis-1/2'>
                          <p className='mt-3'>Sub Title</p>
                          <p className='mt-3'>Discount(%{info.discount})</p>
                          <p className='text-lg font-bold mt-3'>Total</p>
                      </div>
                      <div className='basis-1/2'>
                          <p className='mt-3'>{total}$</p>
                          <p className='mt-3'>{discount}$</p>
                          <p className='mt-3 font-bold' style={{color : '#FFBD59'}}>{lastPrice}$</p>
                      </div>
                </div>
            </div>
        </div>

    </div> 
}

export default Product